import {
  Box,
  Button,
  Flex,
  Modal as ChakraModal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Text,
  Textarea,
  useDisclosure,
  useToast
} from '@chakra-ui/react';
import React from 'react';
import { useForm } from 'react-hook-form';
import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import { api } from '../../../../services/api';
import { useMutation, useQueryClient } from 'react-query';

async function cancelManyLayouts({ selectedLayouts, observacao }) {
  const promises = selectedLayouts.map((layout) => {
    const params = {
      numero_nota: layout.numero_nota,
      sequencia: layout.sequencia,
      codprod: layout.codigo_produto,
      observacao: observacao,
      identificador: layout.id
    };

    return api.post('/site/v2/fluxo-layout/cancelar-layout-pendente', params).then((response) => {
      return response.data;
    });
  });

  const data = await Promise.all(promises);

  return data;
}
const schema = yup.object().shape({
  observacao: yup.string().required('Por favor, digite uma observação')
});

export function ModalCancel({ item, setSelectedLayouts, selectedLayouts }) {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const {
    register,
    handleSubmit,
    formState: { errors }
  } = useForm({
    resolver: yupResolver(schema)
  });

  const queryClient = useQueryClient();

  const toast = useToast({
    position: 'top-right',
    duration: 5000,
    isClosable: true
  });

  const { mutateAsync, isLoading } = useMutation({
    mutationFn: cancelManyLayouts,
    onSuccess: () => {
      setSelectedLayouts([]);

      queryClient.invalidateQueries('info-solicitacao-layout');

      toast({
        title: 'Layouts cancelados com sucesso',
        status: 'success'
      });

      onClose();
    },

    onError: (error) => {
      toast({
        title: 'Erro ao cancelar layouts',
        description: 'Por favor, tente novamente mais tarde',
        status: 'error'
      });
    }
  });

  async function handleCancelSelectedLayouts(data) {
    await mutateAsync({ selectedLayouts, observacao: data.observacao });
  }

  return (
    <>
      <Button display="flex" mb={2} colorScheme="red" size="sm" onClick={onOpen}>
        Cancelar Layouts Selecionados ({selectedLayouts.length})
      </Button>

      <ChakraModal closeOnOverlayClick={false} isOpen={isOpen} onClose={onClose} size="5xl">
        <ModalOverlay />
        <ModalContent as="form" onSubmit={handleSubmit(handleCancelSelectedLayouts)}>
          <ModalHeader>Cancelar Layouts</ModalHeader>
          <ModalCloseButton />
          <ModalBody pb={6}>
            <Box
              w={'100%'}
              mx={'auto'}
              alignItems={'center'}
              justifyContent={'center'}
              display={'flex'}
              flexDirection={'column'}>
              <Flex flexDir={'column'} w={'100%'}>
                <Text as={'h1'} fontSize={'1rem'} fontWeight={'500'} color={'gray.500'}>
                  Observação
                </Text>
                <Textarea
                  placeholder="digite a observação"
                  resize="none"
                  h="10rem"
                  {...register('observacao')}
                />
                {errors.observacao && (
                  <Text color="red" fontSize={'.9rem'}>
                    {errors.observacao.message}
                  </Text>
                )}
              </Flex>
            </Box>
          </ModalBody>

          <ModalFooter>
            <Button
              isLoading={isLoading}
              isDisabled={selectedLayouts.length === 0}
              colorScheme="red"
              type="submit"
              mr={2}>
              Cancelar Layouts
            </Button>

            <Button onClick={onClose}>Cancelar</Button>
          </ModalFooter>
        </ModalContent>
      </ChakraModal>
    </>
  );
}
